<div class="rectified-error-modal-container">
  <div class="rectified-error-modal-container__error">
    {{ 'input_app_error_modal.heading' | translate }}
  </div>
  <div class="rectified-error-modal-container__content">
    <div *ngIf="errorTxt && bctxItemsWithCount.length; else defaultTxt">
      <div class="rectified-error-modal-container__content-error-title">
        {{ errorTxt }}
      </div>
      <ion-row>
        <li *ngFor="let item of errors" class="rectified-error-modal-container__content-error">
          {{ item }}
        </li>
      </ion-row>
    </div>
    <ng-template #defaultTxt>
      {{ 'input_app_common.defaultErrorMessage' | translate }}
    </ng-template>
  </div>
  <div class="rectified-error-modal-container__btn-container">
    <ui-custom-button [btnTxt]="'input_app_common.okay' | translate" (clickEvent)="dismissModal()"></ui-custom-button>
  </div>
</div>
